module.exports = __webpack_public_path__ + "img/0S6A0189.c62cbc0e.jpg";